<template>
    <div>
        <div class="col-md-12">
            <div class="card abtg__default-card abtg__default-card-border">
                <div class="card-head">
                    <header></header>
                </div>
                <div class="card-body ">
            <form @submit.prevent="sendEmail">

                <div class="row" v-if="mailMsg.length > 0">
                    <div class="col">
                        <div class="alert alert-primary" role="alert">
                           Email inviata.
                        </div>
                    </div>
                </div>

                    <div class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                              <label>Email</label>
                            <input type="text" name="email" placeholder="" class="form-control" v-model="formData.email">
                            </div>
                          <div class="form-group">
                            <label>Nome e cognome / Ragione Sociale</label>
                            <input type="text" name="email" placeholder="" class="form-control" v-model="formData.ragione_sociale">
                          </div>
                          <div class="form-group">
                            <label>Pacchetto</label>
                            <select class="form-control" v-model="formData.pack">
                              <option>Real Estate Pro Completo Annuale</option>
                              <option>Real Estate Pro Completo Mensile</option>
                              <option>Real Estate Pro Mercato Libero Mensile</option>
                              <option>Real Estate Pro Aste Annuale</option>
                              <option>Real Estate Pro Aste Mensile</option>
                              <option>Real Estate Pro Annuale</option>
                              <option>Real Estate Pro Mensile</option>
                              <option>Real Estate Pro Lifetime</option>
                            </select>
                          </div>

                          <div class="form-group">
                            <label>Scadenza</label>
                            <input type="date" name="email" placeholder="" class="form-control" v-model="formData.scadenza">
                          </div>

                          <div class="form-group">
                            <label>TIPO ATTIVAZIONE</label>
                            <select class="form-control" v-model="formData.tipo_attivazione">
                              <option>Acquisto</option>
                              <option>In Prova</option>

                            </select>
                          </div>

                          <div class="form-group">
                            <label>Manda email di attivazione in copia a:</label>
                            <input type="text" name="email" placeholder="" class="form-control" v-model="formData.email_plus">
                          </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col">
                            <button type="submit" class="btn btn-default     abtg__btn-star shadow-none abtg__btn-tool">Invia email</button>
                        </div>
                    </div>


            </form>

                  <div class="row mt-4">
                    <div class="col">
                      <table class="table table-bordered">
                        <thead>
                        <tr>
                          <th>Data attivazione</th>
                          <th>Email</th>
                          <th>Ragione Sociale</th>
                          <th>Pacchetto</th>
                          <th>Scadenza</th>
                          <th>Tipo attivazione</th>
                          <th>Email in copia a</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(activation, index) in activationListData">
                          <td>{{activation.created_at}}</td>
                            <td>{{activation.email}}</td>
                            <td>{{activation.ragione_sociale}}</td>
                            <td>{{activation.pacchetto}}</td>
                            <td>{{activation.scadenza}}</td>
                            <td>{{activation.tipo_attivazione}}</td>
                            <td>{{activation.email_plus}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>


                </div>
                <div class="card-footer">
                    <div class="float-right">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'coach/getField',
        mutationType: 'coach/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money},
        data: function () {
            return {

            }
        },

        computed: {
            ...mapFields(['formData', 'mailMsg' , 'activationListData']),
        },
        created: function () {
            this.$store.dispatch('coach/activationList');
        },
        methods: {

            sendEmail: function()
            {
                this.$store.dispatch('coach/sendEmail');
            }
        }
    }
</script>
